export const actionStyles = theme => ({
  root: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center'
  },
  leftAlign: {
    marginLeft: 0,
    marginRight: theme.spacing(3)
  }
});

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: `8px ${theme.spacing(3)}px`,
    minHeight: theme.spacing(9)
  },
  title: {},
  actions: {
    display: 'flex'
  }
});

export default styles;
